var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5912 6.47226H7.27579L8.86882 1.56059C9.0184 0.98542 8.58836 0.417816 8.00126 0.417816H2.61637C2.16763 0.417816 1.7862 0.754594 1.72637 1.20489L0.529725 10.2866C0.458675 10.8315 0.877499 11.3158 1.41973 11.3158H5.85852L4.13461 18.6757C3.99999 19.2509 4.43377 19.792 5.00591 19.792C5.32003 19.792 5.61919 19.6255 5.78373 19.3379L12.3653 7.8345C12.713 7.23284 12.283 6.47226 11.5912 6.47226Z",
    fill: "#F5D33D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTag);
export default __webpack_public_path__ + "static/media/light-tag.8e2391a4b1ead492b7576795b6654d14.svg";
export { ForwardRef as ReactComponent };